import {
  EnvironmentProviders,
  Provider
} from '@angular/core';
import {
  ENVIRONMENT_INITIALIZER,
  inject
} from '@angular/core';
import { LuxonService } from './luxon.service';

export function provideLuxon(): (Provider | EnvironmentProviders)[] {
  return [
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(LuxonService),
      multi: true
    }
  ];
}
